<div class="main-content table-page table-page--compact bitacoras-page">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Bitácoras y reportes</h1>
        <p>Descarga bitácoras, consulta horas validadas y revisa consolidado por proyecto desde una sola vista.</p>
      </div>
    </section>

    <section class="table-page__card">
      <mat-accordion class="bitacoras-page__accordion" multi>
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <i class="material-icons">assignment</i>
              <span>Bitácoras</span>
            </mat-panel-title>
            <mat-panel-description>
              Filtra el rango y descarga la bitácora correcta.
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div class="table-page__toolbar table-page__toolbar--filters bitacoras-page__panel-content">
            <div class="table-page__filters-grid">
              <div class="table-page__filter table-page__filter--medium">
                <mat-form-field appearance="outline" class="table-page__field">
                  <mat-label>Filtro</mat-label>
                  <mat-select [(ngModel)]="filtroSeleccionado" (selectionChange)="ocultarMostrarFiltros($event.value)">
                    <mat-option [value]="1">Todo</mat-option>
                    <mat-option [value]="2">Proyecto</mat-option>
                    <mat-option [value]="3">Área</mat-option>
                    <mat-option [value]="4">Empleado</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="table-page__filter table-page__filter--medium" *ngIf="filtroSeleccionado === 2">
                <mat-form-field appearance="outline" class="table-page__field">
                  <mat-label>Proyecto</mat-label>
                  <mat-select [(ngModel)]="proyectoSeleccionado">
                    <mat-option *ngFor="let proyecto of proyectos" [value]="proyecto">
                      {{ proyecto.nombre }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="table-page__filter table-page__filter--medium" *ngIf="filtroSeleccionado === 3">
                <mat-form-field appearance="outline" class="table-page__field">
                  <mat-label>Área</mat-label>
                  <mat-select [(ngModel)]="areaSelecconada">
                    <mat-option *ngFor="let area of areas" [value]="area">
                      {{ area.area }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="table-page__filter table-page__filter--wide" *ngIf="filtroSeleccionado === 4">
                <mat-form-field appearance="outline" class="table-page__field">
                  <mat-label>Empleado</mat-label>
                  <mat-select [(ngModel)]="empleadoSeleccionado">
                    <mat-option *ngFor="let empleado of empleados" [value]="empleado">
                      {{ empleado.persona.nombreCompleto }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="table-page__filter table-page__filter--narrow">
                <mat-form-field appearance="outline" class="table-page__field">
                  <mat-label>Fecha desde</mat-label>
                  <input matInput [matDatepicker]="dpInicio" [(ngModel)]="fechaInicio" [max]="fechaFin" autocomplete="off" fecha aria-label="Fecha desde">
                  <mat-datepicker-toggle matSuffix [for]="dpInicio"></mat-datepicker-toggle>
                  <mat-datepicker #dpInicio></mat-datepicker>
                </mat-form-field>
              </div>

              <div class="table-page__filter table-page__filter--narrow">
                <mat-form-field appearance="outline" class="table-page__field">
                  <mat-label>Fecha hasta</mat-label>
                  <input matInput [matDatepicker]="dpFin" [(ngModel)]="fechaFin" [min]="fechaInicio" [max]="fechaMax" autocomplete="off" fecha aria-label="Fecha hasta">
                  <mat-datepicker-toggle matSuffix [for]="dpFin"></mat-datepicker-toggle>
                  <mat-datepicker #dpFin></mat-datepicker>
                </mat-form-field>
              </div>
            </div>

            <div class="table-page__toolbar-actions">
              <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="descargarBitacora()">
                <mat-icon>download</mat-icon>
                Descargar bitácora
              </button>
            </div>
          </div>
          <a class="bitacoras-page__download-link" #downloadReporteExcell aria-label="Descargar archivo"></a>
        </mat-expansion-panel>

        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <i class="material-icons">more_time</i>
              <span>Reporte horas trabajadas</span>
            </mat-panel-title>
            <mat-panel-description>
              Consolidado por colaborador con horas validadas.
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div class="table-page__toolbar table-page__toolbar--filters bitacoras-page__panel-content">
            <div class="table-page__filters-grid">
              <div class="table-page__filter table-page__filter--wide">
                <mat-form-field appearance="outline" class="table-page__field">
                  <mat-label>Colaborador</mat-label>
                  <mat-select [(ngModel)]="modelColaboradorHr" (selectionChange)="idColabolador = $event.value">
                    <mat-option>
                      <ngx-mat-select-search [formControl]="colaboradorByHrs" [placeholderLabel]="'Buscar colaborador'" [noEntriesFoundLabel]="'No existe colaborador'">
                      </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let x of filterEmpleadoByHrs | async" [value]="x.usuario.id">
                      {{ x.persona.nombreCompleto }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="table-page__filter table-page__filter--medium">
                <mat-form-field appearance="outline" class="table-page__field">
                  <mat-label>Área</mat-label>
                  <mat-select [(ngModel)]="modelAreaHr" (selectionChange)="idArea = $event.value.id">
                    <mat-option>
                      <ngx-mat-select-search [formControl]="areaByHrs" [placeholderLabel]="'Buscar área'" [noEntriesFoundLabel]="'No existe área'">
                      </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let x of filterAreaByHrs | async" [value]="x">
                      {{ x.area }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="table-page__filter table-page__filter--narrow">
                <mat-form-field appearance="outline" class="table-page__field">
                  <mat-label>Fecha inicio</mat-label>
                  <input class="colorInput" [(ngModel)]="modelFechaInicio" matInput readonly [matDatepicker]="dpInicioReport" (dateChange)="consultaListaSemanal()" [max]="fechaFin" aria-label="Fecha inicio">
                  <mat-datepicker-toggle matSuffix [for]="dpInicioReport"></mat-datepicker-toggle>
                  <mat-datepicker #dpInicioReport></mat-datepicker>
                </mat-form-field>
              </div>

              <div class="table-page__filter table-page__filter--narrow">
                <mat-form-field appearance="outline" class="table-page__field">
                  <mat-label>Fecha fin</mat-label>
                  <input class="colorInput" [(ngModel)]="modelFechaFin" matInput readonly [matDatepicker]="dpFinReport" (dateChange)="consultaListaSemanal()" [min]="minDate" [max]="fechaFin" aria-label="Fecha fin">
                  <mat-datepicker-toggle matSuffix [for]="dpFinReport"></mat-datepicker-toggle>
                  <mat-datepicker #dpFinReport></mat-datepicker>
                </mat-form-field>
              </div>
            </div>

            <div class="table-page__toolbar-actions">
              <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary" (click)="limpiarFormularioReporteHoras()">
                <mat-icon>cleaning_services</mat-icon>
                Limpiar
              </button>
              <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="filtro()">
                <mat-icon>search</mat-icon>
                Consultar
              </button>
            </div>
          </div>

          <div class="bitacoras-page__panel-content bitacoras-page__report-actions">
            <small class="table-page__subtext">Las horas del reporte consideran tiempo validado: normal + aprobado.</small>
            <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="descargarReporteColaborador()">
              <mat-icon>cloud_download</mat-icon>
              Descargar reporte
            </button>
          </div>

          <div class="table-page__table-wrap bitacoras-page__panel-content">
            <table class="table-page__table table-page__table--wide" *ngIf="listaEmpleadoGrid?.length; else emptyHorasTrabajadas">
              <thead>
                <tr>
                  <th>Colaborador</th>
                  <th>Área</th>
                  <th>Puesto</th>
                  <th>Horas validadas</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="
                    let row of listaEmpleadoGrid
                      | paginate
                        : {
                            id: 'bitacorasHoras',
                            itemsPerPage: pageSize,
                            currentPage: currentPageReporteHoras,
                            totalItems: totalRegistrosReporteHoras
                          }
                  "
                >
                  <td>{{ row.nombreCompleto }}</td>
                  <td>{{ row.area.area }}</td>
                  <td>{{ row.puesto.puesto }}</td>
                  <td>{{ row.usuario.horasTrabajadasStr }}</td>
                </tr>
              </tbody>
            </table>

            <ng-template #emptyHorasTrabajadas>
              <div class="table-page__empty">
                <i class="material-icons">hourglass_empty</i>
                <strong>No hay horas trabajadas para los filtros seleccionados</strong>
                <span>Ajusta colaborador, área o rango de fechas para consultar otra vista.</span>
              </div>
            </ng-template>
          </div>

          <div class="table-page__footer" *ngIf="showPaginationReporteHoras">
            <div class="table-page__meta">
              <span>Página {{ currentPageReporteHoras }} de {{ totalPagesReporteHoras || 1 }}</span>
            </div>
            <div class="table-page__pager table-page__pager--ngx">
              <pagination-controls
                [id]="'bitacorasHoras'"
                responsive="true"
                class="my-pagination"
                [directionLinks]="true"
                [autoHide]="false"
                [previousLabel]="labels.previousLabel"
                [nextLabel]="labels.nextLabel"
                [maxSize]="5"
                (pageChange)="consultaPaginaReporteHoras($event)">
              </pagination-controls>
            </div>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <i class="material-icons">text_snippet</i>
              <span>Reporte proyecto</span>
            </mat-panel-title>
            <mat-panel-description>
              Revisión consolidada por proyecto y colaborador.
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div class="bitacoras-page__panel-content">
            <app-reporte-hr-trabajadas></app-reporte-hr-trabajadas>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </section>
  </div>
</div>
